import { gql } from '@apollo/client';
import * as React from 'react';

import { useBreakpoint } from '../../../hooks/useBreakpoint';
import { CalendarIcon, EditIcon } from '../../../icons';
import Dropdown from '../../base/Dropdown';
import { DateRangePicker, DateRangePickerModal, type CalendarDateRange } from '../../DateRangePicker';
import Entity from '../../entity';
import UpdateMerchantModal from '../../UpdateMerchantModal';

import type { MerchantPaneHeaderFragment } from './__generated__/MerchantPaneHeader.gql';

interface IMerchantPaneHeaderProps {
  merchant: MerchantPaneHeaderFragment;
  dateRange?: CalendarDateRange;
  onDateRangeChange: (dateRange: CalendarDateRange) => void;
}

const MerchantPaneHeaderFragment = gql`
  fragment MerchantPaneHeader on Merchant {
    id
    ...EntityAvatar
  }
  ${Entity.Avatar.Fragment}
`;

const MerchantPaneHeader = ({ merchant, dateRange, onDateRangeChange }: IMerchantPaneHeaderProps) => {
  const isMdOrUp = useBreakpoint('md');
  const [isUpdateModalOpen, setIsUpdateModalOpen] = React.useState(false);
  const [isDateRangeModalOpen, setIsDateRangeModalOpen] = React.useState(false);

  return (
    <>
      <Entity.Header
        title={merchant.name}
        avatar={<Entity.Avatar entity={merchant} size="xl" />}
        trailingContent={
          <div className="flex items-center gap-3">
            {isMdOrUp && <DateRangePicker value={dateRange} onChange={onDateRangeChange} defaultValue="past6Months" />}
            <Dropdown.Root>
              <Dropdown.DotsButton className="p-2" />
              <Dropdown.Popover className="w-min">
                <Dropdown.Menu>
                  {!isMdOrUp && (
                    <Dropdown.Item icon={CalendarIcon} onAction={() => setIsDateRangeModalOpen(true)}>
                      Time range&hellip;
                    </Dropdown.Item>
                  )}
                  <Dropdown.Item icon={EditIcon} onAction={() => setIsUpdateModalOpen(true)}>
                    Edit merchant&hellip;
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown.Popover>
            </Dropdown.Root>
          </div>
        }
      />
      <UpdateMerchantModal merchant={merchant} isOpen={isUpdateModalOpen} onOpenChange={setIsUpdateModalOpen} />
      {!isMdOrUp && (
        <DateRangePickerModal
          isOpen={isDateRangeModalOpen}
          onOpenChange={setIsDateRangeModalOpen}
          value={dateRange}
          onChange={onDateRangeChange}
          defaultValue="past6Months"
        />
      )}
    </>
  );
};

MerchantPaneHeader.Fragment = MerchantPaneHeaderFragment;

export default MerchantPaneHeader;
